/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ExtendedJsonSchema } from '@squiz/dxp-ai-client';
import { TableCell } from '@squiz/sds';

export const getTableColumns = (
  properties: Record<string, ExtendedJsonSchema>,
  path: string = '',
): Array<TableCell> => {
  let columns: Array<TableCell> = [];

  for (const [key, value] of Object.entries(properties)) {
    const fullPath = path ? `${path}/${key}` : key;

    if (value.properties) {
      columns = columns.concat(getTableColumns(value.properties, fullPath));
    } else if (value.items) {
      // ignore array properties
      // may be array of scalars or more complex structures
    } else if (value.ui.showInTable === true) {
      columns.push({
        content: `${value.title}`,
        key: fullPath,
      });

      if (path) {
        break;
      }
    }
  }

  return columns;
};
